import { Col, Row, Typography } from 'antd';
import React from 'react';
import styles from './App.module.scss';
const { Title } = Typography;

const Footer = () => {
  return (
    <div className={styles.footer}>
      <Row justify="center">
        <Col>
          <Title level={5}>
            Made with
            <span className={styles.red}> &hearts;</span> in Riihim&auml;ki,
            Finland
          </Title>
        </Col>
      </Row>
      <Row justify="center">
        <Col>
          <Title level={5}>According to tutorial by Aurel Kurtela</Title>
        </Col>
      </Row>
    </div>
  );
};

export default Footer;
